export default {
  paper: {
    background: "transparent",
    borderRight: "0 !important",
    paddingLeft: "60px",
    top: "unset",
    zIndex: 1000
  }
};
